// For v2 of the seismic submittal tool
import axios from 'axios';
import ShortUniqueId from 'short-unique-id';

import _ from 'lodash';

const uid = new ShortUniqueId();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let fetchPromise = null;

export default {
    namespaced: true,

    state: {
        loaded: false,
        data: [],
        defaultSortOrder: [
            'Steel Sch 10',
            'Steel 0.188 Wall',
            'Steel Sch 40',
            'CPVC Sch 40',
            'Mega Flow',
            'Mega Thread',
            'MLT',
            'GL',
            'Eddy Flow',
            'Eddy Thread',
            'Fire-Flo',
            'EZ Thread'
        ],
    },
    getters: {
        pipeFromSizeAndType(state) {
            return (size, type) => {
                return state.data.find(i => (parseFloat(i.size) == size && i.type == type));
            };
        },
        loaded(state) {
            return state.loaded;
        },
        types(state) {
            return [ ...new Set(state.data.map(i => i.type)) ];
        },
        sizes(state) {
            return [ ...new Set(state.data.map(i => i.size)) ];
        },
        allPipes(state) {
            return [ ...new Set(state.data.map(i => i)) ];
        },
        typesFromSize(state) {
            return size => {
                return [ ...new Set(state.data.filter(i => i.size == size).map(i => i.type)) ];
            };
        },
        typesFromMaterial(state) {
            return material => {
                return [ ...new Set(state.data.filter(i => i.material == material).map(i => i.type)) ];
            };
        },
        sizesFromType(state) {
            return type => {
                return [ ...new Set(state.data.filter(i => i.type == type)) ];
            };
        },
        uniqueSizes(state) {
            let pipes = [];

            state.data.forEach(pipe => {
                pipes.push({name: pipe.name, size: parseFloat(pipe.size)});
            });

            return _.uniqWith(pipes, _.isEqual);
        },
    },
    actions: {
        retrievePipes({commit}) {
            return axios.get('/actions/seismic-submittal/pipe/retrieve-pipes')
                .then(r => commit('set', r.data));
        },
    },
    mutations: {
        set(state, data) {
            let tmp = [];

            // append pipes to state in order of default sort
            state.defaultSortOrder.forEach(function(type){
                tmp = _.union(tmp, data.filter(i => i.type == type));
            });

            // append any pipe types that aren't in the default sort at the end            
            tmp = _.union(tmp, data.filter(i => state.defaultSortOrder.includes(i.type) == false));

            state.loaded = true;
            state.data = tmp;
        },
    },
};
